<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="matricula-historico-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="pesquisaHistoricoMatricula" class="form-label">Pesquisar</label>
                                <input id="pesquisaHistoricoMatricula" v-model="search" @keyup="apertouEnter"
                                    type="text" class="form-control form-control-solid"
                                    placeholder="Boletim, informacão" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="dataMinHistoricoMatricula" class="form-label">Data Minima</label>
                                <input id="dataMinHistoricoMatricula" v-model="data_min" @keyup="apertouEnter"
                                    @blur="refreshTable" type="date" class="form-control form-control-solid" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="dataMaxHistoricoMatricula" class="form-label">Data Maxima</label>
                                <input id="dataMaxHistoricoMatricula" v-model="data_max" @keyup="apertouEnter"
                                    @blur="refreshTable" type="date" class="form-control form-control-solid" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2" v-if="status">
                                <label for="statusHistoricoMatricula" class="form-label">Status</label>
                                <Multiselect id="statusHistoricoMatricula" v-model="status_id" :options="status_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-1" v-if="tipos">
                                <label for="tipoHistoricoMatricula" class="form-label">Tipo</label>
                                <Multiselect id="tipoHistoricoMatricula" v-model="tipo_id" :options="tipos_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-lg-3 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                                <button v-if="hasPermissaoEditar" type="button"
                                    class="btn btn-sm btn-pmes-primary" title="Cadastrar"
                                    data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                                    <span class="menu-icon">
                                        <i class="fa fa-plus fa-2x bi"></i>
                                    </span>
                                    Inserir
                                </button>
                            </div>
                        </div>

                        <Cadastro v-if="hasPermissaoEditar" :matricula="matricula" :modal="modal_cadastro"
                            :perfis="perfis" @historico-matricula-criada="refreshTable" />
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Data Pub.</th>
                            <th>Boletim</th>
                            <th>Informacao</th>
                            <th>Status</th>
                            <th>Tipo</th>
                            <th>Responsavel</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaHistoricoService from "@/service/v1/sigap/MatriculaHistoricoService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import Cadastro from "./_Cadastro.vue";
import { Prop } from "vue-property-decorator";

const authStore = namespace("auth");

@Options({
    name: "HistoricoMatriculaIndex",
    components: { CardRh, KDataTable, Multiselect, Cadastro },
})
export default class HistoricoMatriculaIndex extends Vue {
    @Prop() readonly matricula!: any;

    public modal_cadastro = "kt_cadatrar_disciplina_matricula_historico";

    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service = new MatriculaHistoricoService();
    public modelo: any = null;
    public dados: any = null;

    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public status_id: any = null;
    public tipo_id: any = null;
    public matriculaId: any = null;
    public status: any = null;
    public tipos: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.status_id = null;
        this.tipo_id = null;
        this.refreshTable();
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get tipos_select() {
        if (this.tipos) {
            return this.tipos.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getTipos() {
        this.processando = true;
        this.service.getTipos()
            .then(response => {
                this.tipos = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.getStatus();
        this.getTipos();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    status: this.status_id,
                    tipo: this.tipo_id,
                    matriculaId: this.matriculaId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'desc']];
        this.config.columns = [
            { data: "dataPublicacao", name: "dataPublicacao" },
            { data: "docPublicacao", name: "docPublicacao" },
            { data: "observacao", name: "observacao", class: "desktop" },
            { data: "status", name: "status", class: "desktop" },
            { data: "tipo", name: "tipo", class: "desktop" },
            { data: "responsavelId", name: "responsavelId", class: "desktop" },
        ];

        this.config.columnDefs = [
            {
                targets: 0,
                render: (row, type, val) => {
                    return SiteUtils.formatData(val);
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
        ];
    }
}
</script>

<style scoped>
.matricula-historico-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
